interface CircleProgressProps {
  progress: number;
  size: number;
  strokeWidth?: number;
  padding?: number;
  trackColor?: string;
  progressColor?: string;
}

const CircleProgress = (props: CircleProgressProps) => {
  const { progress, size, strokeWidth = 2, padding = 0, trackColor, progressColor } = props;

  const r = size / 2 - strokeWidth / 2;
  const c = 2 * Math.PI * r;

  return (
    <svg
      width={size + 2 * padding}
      height={size + 2 * padding}
      viewBox={`0 0 ${size + 2 * padding} ${size + 2 * padding}`}
    >
      <circle
        cx={(size + 2 * padding) / 2}
        cy={(size + 2 * padding) / 2}
        r={r}
        stroke={trackColor || 'var(--gray100)'}
        strokeWidth={strokeWidth}
        fill="transparent"
      />

      <circle
        cx={(size + 2 * padding) / 2}
        cy={(size + 2 * padding) / 2}
        r={r}
        stroke={progressColor || 'var(--primary)'}
        strokeWidth={strokeWidth}
        fill="transparent"
        strokeDashoffset={`${c * (1 - progress)}px`}
        strokeDasharray={`${c}px`}
        transform={`rotate(-90 ${(size + 2 * padding) / 2} ${(size + 2 * padding) / 2})`}
      />
    </svg>
  );
};

export default CircleProgress;
